import { Chip, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { CheckCircle, Cancel as CancelIcon, Warning as WarningIcon } from '@mui/icons-material'
import React from 'react'
import PropTypes from 'prop-types'

const statusConfig = {
  paid: { label: 'Payé', color: 'success', icon: CheckCircle },
  unpaid: { label: 'Non payé', color: 'warning', icon: WarningIcon },
  completed: { label: 'Complété', color: 'success', icon: CheckCircle },
  pending: { label: 'En attente', color: 'warning', icon: WarningIcon },
  failed: { label: 'Échoué', color: 'error', icon: CancelIcon },
  requires_payment: { label: 'Paiement requis', color: 'error', icon: CancelIcon }
}

function getPaymentStatus(adminData) {
  if (adminData?.paid) {
    return statusConfig[adminData.paid] || { label: adminData.paid, color: 'default', icon: CheckCircle }
  }
  return null
}

function getName(adminData) {
  if (adminData?.firstName || adminData?.lastName) {
    return `${adminData.firstName || ''} ${adminData.lastName || ''}`.trim() || '—'
  }
  return '—'
}

function getEmail(adminData) {
  if (adminData?.email) return adminData.email
  return '—'
}

const reservedSeatShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  seat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  row: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  status: PropTypes.oneOf(['occupied', 'available', 'selected']).isRequired,
  admin_data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    seats: PropTypes.array,
    rows: PropTypes.array,
    categories: PropTypes.array,
    paid: PropTypes.string,
    admin: PropTypes.bool
  })
})

export default function AdminReservationsTable({ reservedSeats }) {
  if (!reservedSeats || reservedSeats.length === 0) {
    return null
  }

  return (
    <Paper elevation={2} sx={{ mt: 3, borderRadius: 3 }}>
      <Table size='small'>
        <TableHead>
          <TableRow sx={{ bgcolor: 'grey.100' }}>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}>Siège</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}>Nom du client</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}>Email</TableCell>
            <TableCell align='center' sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
              Statut de paiement
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reservedSeats.map((seat) => {
            const adminData = seat.admin_data
            if (!adminData) return null

            const status = getPaymentStatus(adminData)
            return (
              <TableRow key={seat.id} sx={{ '&:hover': { bgcolor: 'action.hover' } }}>
                <TableCell>{`${seat.row}-${seat.seat}`}</TableCell>
                <TableCell>{getName(adminData)}</TableCell>
                <TableCell>{getEmail(adminData)}</TableCell>
                <TableCell align='center'>
                  {status ? (
                    <Chip icon={<status.icon />} label={status.label} color={status.color} size='small' />
                  ) : (
                    <Chip label={adminData.admin ? 'Admin' : 'En attente'} size='small' variant='outlined' />
                  )}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </Paper>
  )
}

AdminReservationsTable.propTypes = {
  reservedSeats: PropTypes.arrayOf(reservedSeatShape).isRequired
}
